import { render, staticRenderFns } from "./PrintModel.vue?vue&type=template&id=2b375c28&scoped=true"
import script from "./PrintModel.vue?vue&type=script&lang=js"
export * from "./PrintModel.vue?vue&type=script&lang=js"
import style0 from "./PrintModel.vue?vue&type=style&index=0&id=2b375c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b375c28",
  null
  
)

export default component.exports